module.exports = __webpack_public_path__ + "static/media/PlayingButton.8cb3af34.svg";